import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import { FacilitiesActions } from '../../reducers/facilities/actionNames'
import { getUserObjectId } from '../../reducers/userObject/selectors/object'
import updateFacilities from '../../models/Facilities/updateFacilities'
import { IStore } from '../../reducers'

function* saveFacilities(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdatePrepayments)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, updateFacilities),
      ),
    ])

    const id_object = yield Effects.select(getUserObjectId)
    const facilities = yield Effects.select(
      (state: IStore) => state.facilities.facilities,
    )

    let amentities = {}

    Object.entries(action.payload).forEach(([key, value]) => {
      const splitKey = key.split(':')

      const sanitizedKey = splitKey[1]
        .replace('BBO_3139_', '')
        .replace('BED_11593_', '')
        .replace(/_/g, ' ')
      const sanitizedCategoryKey = splitKey[0]
        .replace('BBO_3139_', '')
        .replace('BED_11593_', '')
        .replace(/_/g, ' ')

      facilities.forEach(facility => {
        if (
          facility.name.toLowerCase() === sanitizedKey.toLowerCase() &&
          facility.category.toLowerCase() === sanitizedCategoryKey.toLowerCase()
        ) {
          if (value[2]) {
            amentities = {
              ...amentities,
              [facility.id]: value[3] === '1' ? value[4] : [0],
            }
          }
        }
      })
    })

    yield Effects.call(service, {
      id_object: id_object,
      amentities: amentities,
    })

    // yield Effects.put({
    //   services,
    //   type: PaymentDictionaryActions.AcceptedPrepayment,
    // })
    yield put(fireToastSuccess(i18n.t('user_settings_updated')))
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeEvery(FacilitiesActions.SaveFacilities, saveFacilities)
}
